// extracted by mini-css-extract-plugin
module.exports = {"heading":"OIUhMT8TznBgsfh1trp_v","list":"_1yrhY5EgNcnGtZzz9Fh5yD"};